'use strict'
module.exports = require('./lib')(require('./lib/elliptic'))



//////////////////
// WEBPACK FOOTER
// ./~/secp256k1/elliptic.js
// module id = 165
// module chunks = 0